export default __webpack_public_path__ + "static/11-79251cdfdd46299b07e29a370545d4f5.jpg";